import { MgPrisFeature } from '@retail/mgpris/config-types';
import React, { PropsWithChildren } from 'react';
import { useIsFeatureEnabled } from './useFeatureContext';

interface Props extends PropsWithChildren {
  feature: MgPrisFeature;
}

export const FeatureFlag: React.FC<Props> = ({ feature, children }) => {
  const isFeatureEnabled = useIsFeatureEnabled(feature);
  if (!isFeatureEnabled) {
    return null;
  }
  return children;
};
